// extracted by mini-css-extract-plugin
module.exports = {"block__addButton":"style_block__addButton__3jH6L","item":"style_item__2HAiw","item__button":"style_item__button__1edig","item__input":"style_item__input__1DajB"};